import * as R from 'ramda';
import { translations } from '../config/translations';
import settings from '../config';

const exists = R.both(R.complement(R.isNil), R.complement(R.isEmpty));

let language;

export const init_translations = session => {
  if (session.value().user) {
    language = exists(session.value().user.language)
      ? session.value().user.language
      : language;
    settings.supported_languages = exists(session.value().api_config)
      ? Object.keys(session.value().api_config.supported_languages)
      : settings.supported_languages;

    // TODO: remove this subscription, replace with a call to a setter function

    session.subscribe(items => {
      language = items?.user?.language || 'en';
    });
  }
};

export const init_debug_translations = () => {
  window.wp.translations = translations;
};

export const set_language = lang => {
  language = lang;
};

export const translate = (text, values) => {
  if (!text) return text;

  const lang = language; // TODO: get_language, abban pedig get_supported_languages
  let dict;
  const placeholders = ['%s', '%d'];
  let translated;

  try {
    dict = translations[text];
  } catch (TypeError) {
    console.error('Missing translation: ', text);
    dict = null;
  }

  if (!dict) {
    translated = text;
  } else if (!!dict && !dict[lang]) {
    translated = dict.en;
  } else {
    translated = dict[lang];
  }

  if (values) {
    for (const i of placeholders) {
      if (translated.includes(i)) {
        while (translated.includes(i)) {
          translated = translated.replace(i, values.shift());
        }
      }
    }
  }

  return translated;
};

export const t9n = (text, ...values) => {
  return translate(text, [...values]);
};
